import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../../models/api-resource.interface';
import { Team } from './../../teams/team.interface';

export class TeamService {
   async getTeams(tenantId: number, query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Team>>>(`/tenants/${tenantId}/teams`, { params: { ...query } });
      return response.data;
   }

   async getTeam() {
      throw Error('Method not implemented');
   }

   async postTeam(tenantId: number, team: Team) {
      const response = await http.post<Team>(`/tenants/${tenantId}/teams`, team);
      return response.data;
   }

   async putTeam() {
      throw Error('Method not implemented');
   }

   async deleteTeam(tenantId: number, teamId: number) {
      const response = await http.delete(`/tenants/${tenantId}/teams/${teamId}`);
      return response.data;
   }
}
